// source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/ru.xml#L1825
module["exports"] = {
  wide: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
  wide_context: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
  abbr: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
  abbr_context: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"]
};